import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

/**
 * Shown while a lazily-loaded route chunk is being fetched.
 *
 * Rendered inside MainLayout, so the sidebar and header stay put and only the
 * content area swaps — the page should feel like it is filling in, not like the
 * app disappeared. Deliberately generic: it stands in for list pages, detail
 * pages and reports alike.
 */
const RouteFallback: React.FC = () => {
  return (
    <div className="space-y-6 p-1" role="status" aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading page…</span>

      {/* Page heading + primary action */}
      <div className="flex items-center justify-between gap-4">
        <div className="space-y-2">
          <Skeleton className="h-7 w-56" />
          <Skeleton className="h-4 w-80" />
        </div>
        <Skeleton className="h-9 w-32" />
      </div>

      {/* Filter / toolbar row */}
      <div className="flex flex-wrap items-center gap-3">
        <Skeleton className="h-9 w-64" />
        <Skeleton className="h-9 w-36" />
        <Skeleton className="h-9 w-36" />
      </div>

      {/* Content block */}
      <div className="rounded-md border border-border">
        <Skeleton className="h-11 w-full rounded-b-none" />
        <div className="space-y-3 p-4">
          {Array.from({ length: 8 }).map((_, index) => (
            <Skeleton key={index} className="h-10 w-full" />
          ))}
        </div>
      </div>
    </div>
  )
}

export default RouteFallback
